import { useMemo } from 'react'
import useGetExtendedColumns from './useGetExtendedColumns'

/**
 * Get merged extended columns from multiple tables, unifying columns with the same label
 * @param {string} tableName1
 * @param {string} tableName2
 */
const useGetMergedExtendedColumns = (tableName1, tableName2) => {
  const columnSet1 = useGetExtendedColumns(tableName1)
  const columnSet2 = useGetExtendedColumns(tableName2)

  return useMemo(() => {
    if (columnSet1 === undefined || columnSet2 === undefined) return undefined

    const mergedMap = new Map()

    for (const column of columnSet1) {
      mergedMap.set(column.name, { ...column })
    }

    for (const column of columnSet2) {
      if (!mergedMap.has(column.name)) {
        mergedMap.set(column.name, { ...column })
      }
    }

    return Array.from(mergedMap.values())
  }, [columnSet1, columnSet2])
}

export { useGetMergedExtendedColumns }
export default useGetMergedExtendedColumns
